import * as React from 'react';
import { NavItem, NavItemRef } from 'Interfaces/Admin';
import ColumnItem from './ColumnItem';

interface Props {
  items: NavItem[];
  /** The item in this column that the user drilled into or opened. */
  selected: NavItemRef | null;
  /** True when the selection lies further right, so this row is only a trail marker. */
  isTrail: boolean;
  onSelect: (item: NavItem) => void;
  onDrillDown: (item: NavItem) => void;
}

/** One panel of the column stack. Replaces PanelView.js. */
export default function Column(props: Props) {
  const { items, selected } = props;
  return (
    <div className="admin-column">
      {items.map((item) => {
        const isSelected = !!selected && selected.type === item.type && selected.id === item.id;
        return (
          <ColumnItem
            key={`${item.type}-${item.id}`}
            item={item}
            selected={isSelected && !props.isTrail}
            onTrail={isSelected && props.isTrail}
            onSelect={() => props.onSelect(item)}
            onDrillDown={() => props.onDrillDown(item)}
          />
        );
      })}
    </div>
  );
}
